import React from 'react';

const ChevronRightIcon = () => (
  <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.73874 1.26025C1.36592 0.852793 0.733376 0.824721 0.325922 1.19755C-0.081533 1.57037 -0.109605 2.20292 0.263221 2.61037L4.04222 6.74037C4.26626 6.98522 4.58408 7.09307 4.89048 7.05925C5.19689 7.09307 5.51471 6.98522 5.73874 6.74037L9.51774 2.61037C9.89057 2.20292 9.8625 1.57037 9.45504 1.19755C9.04759 0.824721 8.41505 0.852793 8.04222 1.26025L4.89048 4.70473L1.73874 1.26025Z"
      fill="white"
    />
  </svg>
);

export default ChevronRightIcon;
